import SendEmailTemplate from './send-email-template';
import './send-email-template.scss';

export default SendEmailTemplate;
